import Vue from 'vue'
import { Alert } from 'element-ui'

function _initAlert () {
  var AlertConstructor = Vue.extend(Alert)
  var alertCom = new AlertConstructor({props: {title: ''}}).$mount()
  alertCom.visible = false
  alertCom.title = '请先选择一行'
  alertCom.type = 'warning'
  alertCom.showIcon = true
  return alertCom
}

export default {
  data () {
    return {
      currentRow: null,
      unSelectedTipTarget: '.table-container',
      $_alert: null
    }
  },
  methods: {
    selectRow (currentRow, oldCurrentRow) {
      this.currentRow = currentRow
    },
    hasSelectedRow (handler, unSelectedHandler) {
      if (this.currentRow && this.currentRow.id > 0) {
        this.hideWarn()
        handler(this.currentRow)
      } else {
        this.warn()
        if (unSelectedHandler) {
          unSelectedHandler()
        }
      }
    },
    warn () {
      this.alert.visible = true
    },
    hideWarn () {
      if (this.$_alert) {
        this.alert.visible = false
      }
    },
    insertAlert () {
      var parent = document.querySelector(this.unSelectedTipTarget)
      parent.insertBefore(this.alert.$el, parent.firstChild)
    },
    cancelSelectedRow () {
      this.hideWarn()
      this.currentRow = null
    }
  },
  computed: {
    alert () {
      if (!this.$_alert) {
        this.$_alert = _initAlert()
        this.insertAlert()
      }
      return this.$_alert
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/table-row-select.js